module.exports = __webpack_public_path__ + "static/media/S_S03.f228d0f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BLUE/S_S03.png
// module id = 85
// module chunks = 0